/* English/Arabic strings for the hub console. Phase 2 covered the shell and the theme
   settings screen; Phase 3 migrated every stylesheet to logical CSS properties (so
   `dir="rtl"` mirrors layout correctly, not just text) and extracts the remaining
   screens' strings. Two exceptions stay physical, documented in components.css:
   the progress-fill shimmer (a direction-agnostic loading convention) and the XML/code
   line-number gutter (code content is always LTR). */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ar from "./ar.json";
import en from "./en.json";

export type UiLanguage = "en" | "ar";

export const RTL_ENABLED = true;

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnNull: false,
  });
}

export function applyLanguage(language: UiLanguage): void {
  if (i18n.language !== language) void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  document.documentElement.dir = RTL_ENABLED && language === "ar" ? "rtl" : "ltr";
}

export default i18n;
